/**
 * @description Notification component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/Notification
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * @description The Notification component.
 * @class 
 * @extends {React.Component}
 */
class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.actionButton = React.createRef();
        this.closeButton = React.createRef();
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        this.props.notification.hasAction
            ? this.actionButton.current.focus()
            : this.closeButton.current.focus();
    }

    /**
     * @inheritdoc
     */
    render() {
        return (
            <div className={`Notification ${this.props.notification.type}`}>
                <div className="Notification-header">
                    <div className="Notification-title">
                        {this.props.notification.title}
                    </div>
                    <button
                        ref={this.closeButton}
                        className="Notification-close-button"
                        onClick={this.handleCloseClick.bind(this)}>
                        <span className="material-icons">close</span>
                    </button>
                </div>
                <hr />
                <div className="Notification-body">
                    <div className="Notification-message">
                        {this.props.notification.message}
                    </div>
                    {this.props.notification.hasAction && (
                        <button
                            ref={this.actionButton}
                            className="Notification-action-button"
                            type="button"
                            onClick={this.handleActionButtonClick.bind(this)}>
                            {this.props.notification.actionButtonText}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    /**
     * @description Handles the click of the close button.
     */
    handleCloseClick() {
        this.props.onCloseNotification(this.props.notification.id);
    }

    /**
     * @description Handles the click of the action button.
     */
    handleActionButtonClick() {
        this.props.onClickNotificationAction(this.props.notification.id);
    }
}

Notification.defaultProps = {
    notification: {
        id: 0,
        title: '',
        message: '',
        actionButtonText: ''
    },
    onCloseNotification: () => null,
    onClickNotificationAction: () => null
};

Notification.propTypes = {
    notification: PropTypes.object.isRequired,
    onCloseNotification: PropTypes.func.isRequired,
    onClickNotificationAction: PropTypes.func.isRequired
};

export default Notification;
